import { InvoicesTable } from "components";

const Invoices = () => {



    return (
        <InvoicesTable />
    );

}
export default Invoices;